import React from 'react'
import { navigate } from 'gatsby'

import { useResearchApiData } from '../../hooks/graphqlStaticQuery/useResearchApiData'
import { isBrowser } from '../../utils/generic'
import { Layout } from '../../atomic-components/organisms/layout'
import { Seo } from '../../atomic-components/organisms/seo'

const Research = ({ pageContext: { slug } }) => {
  const { pages } = useResearchApiData()

  const [page] = pages.filter((page) => page.slug === slug)
  if (page.length === 0 && isBrowser()) navigate('/404')

  if (typeof page === 'undefined') return <div />

  return (
    <Layout>
      <section dangerouslySetInnerHTML={{ __html: page?.content?.rendered }} />
    </Layout>
  )
}

export default Research

export const Head = ({ pageContext: { slug }, location: { pathname } }) => {
  const { pages } = useResearchApiData()
  const page = pages.find((page) => page.slug === slug)
  const yoastHead = { yoast_head_json: page?.yoast_head?.json }

  return (
    <Seo
      yoast={yoastHead}
      title={page.title.rendered}
      description={page.excerpt.rendered}
      pathname={pathname}
      // href_langs={page?.acf?.href_language_tags}
    />
  )
}
